import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { RESPONSIBLE_USE_BOUNDARY_TEXT } from '../../domain/externalReview/externalReviewCopy';

type Props = {
  /** When omitted, uses the canonical Epic 160 responsible-use copy. */
  text?: string;
};

export default function ResponsibleUseBoundary({ text = RESPONSIBLE_USE_BOUNDARY_TEXT }: Props) {
  const body = text.replace(/^Responsible-use boundary:\s*/i, '');
  return (
    <Alert severity="info" variant="outlined" data-testid="responsible-use-boundary">
      <AlertTitle>Responsible-use boundary</AlertTitle>
      {body}
    </Alert>
  );
}
